import { gql } from '@apollo/client';

export const getMandantLink = gql`
  query getMandantLink($id: ID!) {
    getMandantLink(id: $id) {
      _id
      label
      url
      linkType
    }
  }
`;

export const getMandantLinks = gql`
  query getMandantLinks($mandantId: ID, $registerId: ID) {
    getMandantLinks(mandantId: $mandantId, registerId: $registerId) {
      _id
      label
      url
      linkType
    }
  }
`;

export const getAgbLink = gql`
  query getAgbLink($registerId: ID) {
    getAgbLink(registerId: $registerId) {
      _id
      label
      url
      linkType
    }
  }
`;

export const createMandantLink = gql`
  mutation createMandantLink(
    $mandantId: ID!
    $label: String!
    $url: String!
    $linkType: MandantLinkType!
  ) {
    createMandantLink(
      mandantId: $mandantId
      label: $label
      url: $url
      linkType: $linkType
    ) {
      _id
    }
  }
`;

export const updateMandantLink = gql`
  mutation updateMandantLink(
    $id: ID!
    $label: String
    $url: String
    $linkType: MandantLinkType
  ) {
    updateMandantLink(id: $id, label: $label, url: $url, linkType: $linkType)
  }
`;

export const deleteMandantLink = gql`
  mutation deleteMandantLink($id: ID!) {
    deleteMandantLink(id: $id)
  }
`;
